import React,  { useState } from "react"
import axios from 'axios';
import DefaultTemplate from "../templates/DefaultTemplate";
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import Button from '@material-ui/core/Button';
import AlertDialog from "../templates/AlertDialog";
import MarkdownIt from 'markdown-it'
import MdEditor, {Plugins} from 'react-markdown-editor-lite'
import 'react-markdown-editor-lite/lib/index.css';
import hljs from 'highlight.js';
import 'highlight.js/styles/vs.css';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    /*'& label.Mui-focused': {
      color: '#60da68',
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: '#60da68',
    },*/
  },
  margin: {
    margin: "5px 5px",
  },
  withoutLabel: {
    marginTop: theme.spacing(1),
  },
  textField: {
    width: '20ch',
  },
  w100:{
    width:"100%",
  },
  buttonArea: {
    margin: "20px auto 20px auto",
  },
  horizontalMargin :{
    margin: "0 10px 0 10px"
  },
  mdeRoot:{
    width:"100%",
    margin:theme.spacing(1),
    zIndex:9999,
  },
  labelStyle:{
    color:"rgba(255, 255, 255, 0.7)",
  },
}))

const now = () => {
  const dt = new Date()
  return dt.getFullYear() + '-' + ('0' + (dt.getMonth() + 1)).slice(-2) + '-' + ('0' + dt.getDate()).slice(-2)
}

MdEditor.use(Plugins.TabInsert, {
  tabMapValue: 1,
})

const mdParser = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true,
  highlight(str, lang) {
    if (lang && hljs.getLanguage(lang)) {
      try {
        return hljs.highlight(lang, str).value
      } catch (__) {}
    }
    return ''
  },
})

const AddEntry = () => {
  const classes = useStyles()
  const [values, setValues] = useState({
    entryId: 0,
    title: '',
    publishDate:now(),
    isPublished:1,
    entryCode: '',
    category: '',
    authorId :1,
    content: '',
  })
  const [errors, setErrors] = useState({
    title:false,
    publishDate:false,
    entryCode:false,
    content:false,
    category:false,
  })
  const [dialogData, setDialogData] = useState({isOpen:false, title:"error", message: ""});
  const handleChange = (prop) => (event) => {
    if(event.target.type === 'radio'){
      setValues({ ...values, [prop]: parseInt(event.target.value) })
    }else{
      setValues({ ...values, [prop]: event.target.value })
    }
  };
  const handleEditorChange = ({text, html}) => {
    setValues({ ...values, content: text })
  }
  const handleRegisterButtonClick = () => {
    setErrors({ ...errors, title:true})
  }
  const handleImageUpload = async (file) => {
    try{
      const data = new FormData();
      data.append('image', file) // filenameに空白があるとレンダリングに失敗する(サーバ側で空白を許可しないようにする)
      const result = await axios.post('/test-image/Upload.php', data, {headers:{'Content-Type': 'multipart/form-data'}})
      return new Promise(resolve => {
          resolve(result.data.filepath)
      })
    }catch(error){
      setDialogData({isOpen:true, title:"Error", message: error.response.status + " " + error.response.statusText});
    }
  };
  const renderHTML = (text) => {
    return mdParser.render(text)
  }
  return(
    <DefaultTemplate title="Add Entry">
      <div className={classes.root}>
      <Grid container className={classes.margin}>
      <Grid item xs={6}>
          <TextField
            id="publishDate"
            required
            label="Publish Date"
            type="date"
            value={values.publishDate}
            onChange={handleChange('publishDate')}
            className={classes.textField}
            InputLabelProps={{
              shrink: true,
            }}
            error={errors.publishDate}
            helperText={errors.publishDate ? 'Empty!' : ' '}
          />
          </Grid>
          <Grid item xs={6}>
          <label className={classes.labelStyle}>Status</label>
        <RadioGroup row required aria-label="isPublished" name="isPublished" value={values.isPublished} onChange={handleChange('isPublished')}>
            <FormControlLabel value={1} control={<Radio color="primary" required={true} />} label="公開" />
            <FormControlLabel value={0} control={<Radio color="secondary" required={true} />} label="非公開" />
          </RadioGroup>
          </Grid>
          </Grid>

          <Grid container className={classes.margin}>
          <Grid item xs={12}>
          <TextField
            id="title"
            required
            label="Title"
            type="text"
            value={values.title}
            onChange={handleChange('title')}
            inputProps={{maxLength:100}}
            error={errors.title}
            helperText={errors.title ? 'Empty!' : ' '}
            className={classes.w100}
          />
                  </Grid>
          </Grid>
        
          <Grid container className={classes.margin}>
          <Grid item xs={12}>
          <TextField
            id="entryCode"
            required
            label="Entry Code"
            value={values.entryCode}
            onChange={handleChange('entryCode')}
            inputProps={{maxLength:100}}
            error={errors.entryCode}
            helperText={errors.entryCode ? 'empty!' : ' '}
            className={classes.w100}
          />
                  </Grid>
          </Grid>

          <Grid container className={classes.margin}>
          <Grid item xs={12}>
          <TextField
            id="category"
            label="Category"
            value={values.category}
            onChange={handleChange('category')}
            inputProps={{maxLength:255}}
            error={errors.category}
            helperText={errors.category ? 'empty!' : ' '}
          />
         </Grid>
          </Grid>

        <div className={classes.mdeRoot}>
          <label className={classes.labelStyle}>Content</label>
            <MdEditor
              style={{ height: "600px" }}
              renderHTML={renderHTML}
              onChange={handleEditorChange}
              onImageUpload={handleImageUpload}
              /*onCustomImageUpload={handleImageUpload}*/
              fullScreen={false}
              config={{
                view: {
                  menu: true,
                  md: true,
                  html: true,
                },
                hideMenu: true,
                
                table: {
                  maxRow: 5,
                  maxCol: 6,
                },
                syncScrollMode: ['leftFollowRight', 'rightFollowLeft'],
                imageAccept:'.jpg,.png',
              }}
            />
        </div>
        <div className={classes.buttonArea}>
          <Button variant="contained" color="primary" className={classes.horizontalMargin} onClick={handleRegisterButtonClick}>
          Register
          </Button>
          <Button variant="contained" color="default" className={classes.horizontalMargin}>
          Clear
          </Button>
          {/*<Button variant="contained" color="secondary" className={classes.horizontalMargin}>
          Delete
          </Button>*/}
        </div>
      </div>
      <AlertDialog isOpen={dialogData.isOpen} title={dialogData.title} message={dialogData.message} />
    </DefaultTemplate>
  )
}

export default AddEntry;